<template>
    <div class="contacts-tab">
        <div class="tabulation-title" :style="'color:' + titlesColor">
            <h5>
                {{ index }}.
                <span v-if="!newTitle">
                   Contacts
                </span>
                <span v-else>
                    {{newTitle}}
                </span>
            </h5>
        </div>

        <v-alert type="info"
                 class="mb-5 form-container mr-auto ml-auto"
                 border="right"
                 :color="primaryColor"
                 colored-border
                 v-if="helpDesc"
        >
            <div>{{helpDesc}}</div>
        </v-alert>

        <div class="form-container mr-auto ml-auto mt-3">
            <div class="mt-5">
                <div class="d-flex justify-start flex-wrap" style="margin-left: -20px; margin-right: -20px">
                    <div v-for="(contact, index) in provider.contacts"
                         class="mb-5 mt-5"
                         style="margin-left: 20px; margin-right: 20px">
                        <apidae-contact-card :contact="contact" :fields="tabulationFields"></apidae-contact-card>
                    </div>

                    <add-button v-if="!readOnly"></add-button>

                    <add-apidae-contact-modal :fields="tabulationFields"></add-apidae-contact-modal>
                </div>
            </div>
        </div>

        <confirm ref="confirm"></confirm>
    </div>
</template>

<script>
import {mapGetters, mapMutations, mapState} from "vuex"
import Confirm from "../../../tools/Confirm"
import ApidaeContactCard from "../form-components/apidae-contact/ApidaeContactCard.vue"
import AddButton from "../form-components/apidae-contact/AddButton.vue"
import AddApidaeContactModal from "../form-components/apidae-contact/AddApidaeContactModal.vue"

export default {
    name: "ApidaeContacts",
    components: {AddApidaeContactModal, AddButton, ApidaeContactCard, Confirm},
    props: ['index', "newTitle", "helpDesc"],
    methods: {
        initContacts() {
            this.provider.contacts.forEach(contact => {
                contact.uid = Math.random().toString(36).substr(2, 16)
            })
        }
    },
    computed: {
        ...mapState('web_form', ['provider', 'readOnly']),
        ...mapState('webFormStyle', ['titlesColor', 'primaryColor']),
        ...mapGetters('web_form', ['getFieldsFromTabulation']),
        tabulationFields() {
            return this.getFieldsFromTabulation('CONTACTS').sort((a, b) => a.order - b.order)
        }
    },
    created() {
        this.initContacts()

        this.$global.$on("init-contacts", () => {
            if(this.provider) {
                this.initContacts()
            }
        })
    }
}
</script>
